import { PHONE, locationSchema } from "../structured-data-core";

export function getBocaRatonStructuredData() {
  const url = "https://restorehair.com/locations/florida/boca-raton/";
  const description =
    "Find out about your hair transplant options in Boca Raton with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Boca Raton", "2255 Glades Road, Suite 324A", "Boca Raton", "FL", PHONE, url, description),
  ];
}
